const Discount = {
    init: function () {
        this.copyVoucher();
        this.collectVoucher();
    },

    copyVoucher: function () {
        $(document).on('click', '.btn-copy-voucher', function () {
            const code = $(this).data('code');

            if (!code) {
                showToast(window.Trans.copy_failed, 'error');
                return;
            }

            if (navigator.clipboard) {
                navigator.clipboard.writeText(code).then(() => {
                    Discount.afterCopy();
                }).catch(() => {
                    Discount.fallbackCopy(code);
                });
            } else {
                Discount.fallbackCopy(code);
            }
        });
    },

    fallbackCopy: function (text) {
        try {
            const $input = $('<input>');
            $('body').append($input);
            $input.val(text).select();
            document.execCommand('copy');
            $input.remove();

            Discount.afterCopy();
        } catch (e) {
            showToast(window.Trans.copy_failed, 'error');
        }
    },

    afterCopy: function () {
        showToast(window.Trans.voucher_code_copied, 'success');
    },

    collectVoucher: function () {
        $(document).on('click', '.btn-collect-voucher', function () {
            const $btn = $(this);
            const discountId = $btn.data('id');

            if (!discountId) {
                return;
            }

            // Disable button to prevent double submission
            $btn.prop('disabled', true);
            const originalText = $btn.text();
            $btn.text(window.Trans.loading || 'Loading...');

            $.ajax({
                url: window.collectVoucherUrl || '/customer/coupon/collect',
                type: 'POST',
                dataType: 'json',
                data: {
                    discount_id: discountId,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    if (response.error) {
                        showToast(response.message || window.Trans.collectError, 'error');
                    } else {
                        showToast(response.message || window.Trans.collectSuccess, 'success');
                        // Hide the voucher item without reloading
                        const $item = $btn.closest('.voucher-wallet__item-wrapper');
                        $btn.text(window.Trans.collected || 'Collected');
                        $item.fadeOut(300, function () {
                            $item.remove();
                        });
                    }
                },
                error: function (xhr) {
                    let message = window.Trans.error_occurred;
                    if (xhr.responseJSON && xhr.responseJSON.message) {
                        message = xhr.responseJSON.message;
                    }
                    showToast(message, 'error');
                },
                complete: function () {
                    $btn.prop('disabled', false);
                    $btn.text(originalText);
                }
            });
        });
    },
};

$(function () {
    Discount.init();
});
